// @flow
/* global window: true */

import * as React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { selectUserCountryCode } from '@gandi/authentication';
import { selectFromConfig } from '@gandi/redux-config';
import { type TranslatorProps, withTranslator } from '@gandi/translate';
import { AddonButton, Base, Text, Svg } from '@gandi/ui';

import type { FullState } from '../../../types';

import styles from './PhoneFloatingBox.scss';

type Props = {
  translator: TranslatorProps,
  countryCode: string,
  enabled: boolean,
  ...
};

type State = {
  enabled: boolean,
  hidden: boolean,
  mounted: boolean,
  ...
};

// Get Pacific time
// Courtesy of gandi.web
function getTime() {
  const offset = new Date().getTimezoneOffset() / 60;
  const localHour = new Date().getHours();
  let PSTHour = localHour + offset - 7;
  PSTHour = PSTHour > 0 ? PSTHour : PSTHour + 24;

  return PSTHour;
}

class PhoneFloatingBox extends React.Component<Props, State> {
  state: State = (() => {
    const hours = getTime();

    return {
      enabled:
        this.props.enabled &&
        this.props.countryCode === 'US' &&
        hours >= 9 &&
        hours < 17,
      mounted: false,
      hidden: false,
    };
  })();

  componentDidMount() {
    const shouldNotShow =
      !window.sessionStorage ||
      window.sessionStorage.getItem('dismiss-phone-widget');

    this.setState({
      mounted: true,
      hidden: shouldNotShow,
    });
  }

  shouldComponentUpdate(nextProps: Props, nextState: State): boolean {
    const hide =
      !this.state.enabled || !this.state.mounted || this.state.hidden;
    const nextHide = !nextState.mounted || nextState.hidden;
    return hide !== nextHide;
  }

  handleClose: (evt: SyntheticMouseEvent<>) => void = (
    evt: SyntheticMouseEvent<>,
  ) => {
    evt.preventDefault();

    this.setState({
      hidden: true,
    });

    if (window.sessionStorage) {
      window.sessionStorage.setItem('dismiss-phone-widget', true);
    }
  };

  render(): null | React.Node {
    const {
      translator: { __ },
    } = this.props;

    const hide =
      !this.state.enabled || !this.state.mounted || this.state.hidden;
    if (hide) return null;

    return (
      <Base
        flex
        flexAlignItemsCenter
        flexJustifyBetween
        position="fixed"
        padding="xsmall"
        backgroundColor="white"
        className={styles.root}
      >
        <Svg name="gandiIcon" theme="green" />
        <Base tagName="p" margin="none" className={styles.paragraph}>
          <Text weight="semibold">{__('Have questions? ')}</Text>
          <Text weight="regular">
            {__('Call us:')} <a href="tel:+14154294923">415-429-4923</a>
          </Text>
        </Base>
        <AddonButton
          hitzone="overlay"
          intent="remove"
          onClick={this.handleClose}
        >
          {__('Close')}
        </AddonButton>
      </Base>
    );
  }
}

const selectPhoneNumberEnabled = selectFromConfig<boolean>(
  'flags.ENABLE_PHONE_NUMBER_WIDGET',
  false,
);

const mapStateToProps = (state: FullState) => ({
  countryCode: selectUserCountryCode(state),
  enabled: selectPhoneNumberEnabled(state),
});

export default (compose(
  withTranslator({ propsNamespace: 'translator' }),
  connect(mapStateToProps),
)(PhoneFloatingBox): React.ComponentType<{}>);
